import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

export default function PillTab({ tabs, activeTab, onTabChange, variant = 'pill', className = '', tabClassName = '' }) {
  const { t } = useTranslation();
  if (variant === 'segmented') {
    return (
      <div className={`inline-flex items-center border border-mono-200 rounded h-8 ${className}`}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 h-full flex items-center justify-center text-xs rounded transition-colors ${
              activeTab === tab.id
                ? 'font-semibold text-mono-900'
                : 'font-medium text-mono-500 hover:text-mono-700'
            } ${tabClassName}`}
          >
            {tab.icon && <Icon name={tab.icon} size={14} className="mr-1" />}
            {tab.labelKey ? t(tab.labelKey) : tab.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex flex-wrap items-center gap-2.5 ${className}`}>
      {tabs.map((tab) => (
        <div key={tab.id} className="relative group">
          <button
            onClick={() => onTabChange(tab.id)}
            className={`h-8 px-4 rounded-pill text-2sm font-bold transition whitespace-nowrap flex items-center gap-1.5 ${
              activeTab === tab.id
                ? 'bg-orange-500 text-white hover:bg-orange-600'
                : 'bg-white text-mono-700 border border-mono-700 hover:bg-orange-500 hover:text-white hover:border-orange-500'
            } ${tabClassName}`}
          >
            {tab.icon && <Icon name={tab.icon} size={14} />}
            {tab.labelKey ? t(tab.labelKey) : tab.label}
          </button>
          {tab.tooltip && (
            <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-9 px-2.5 py-1 rounded-lg bg-orange-500 text-white text-2xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 shadow-sm">
              <Icon name="time" size={12} className="inline-block mr-1 align-[-2px]" />
              {tab.tooltip}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
